import '../style/styleDefault.css'
import '../style/styleMobile.css'
import '../style/styleOrdi.css'
import '../style/styleTab.css'
import logo_lopcus from '../ressources/logo_lopcus_couleur.png'
import img_partenaires from '../ressources/Logos_5.jpg'

import { default as translate } from '../i18n/translate'

function Accueil() {
  
    return (
        <main id="mainTemplate" className="m-t-p-6" style={{display: "flex"}}>
            <div className="timeline-div">
                <div className="timeline"></div>
            </div>
            <div id="formulaireAMI" className="grid-1-3-1-xl" style={{width: "100%", height: "100%", overflow: "hidden", marginTop: "30px"}}>
                <img id="titleNav" src={logo_lopcus} alt="logo" style={{height: "100px", gridColumn: "1", padding: "10 0 0 10px", backgroundColor: "white"}}></img>
                <div className="textAppContainer">
                    <div className="textApp" style={{height: "100%", gridColumn: "2"}}>
                        <div style={{maxWidth: "1000px", margin: "auto"}}>
                            <h2 style={{textAlign: "left"}}>
                            {translate("accueil.ami_texte")}</h2>
                            <span>{translate("accueil.ami_into_titre")}</span><br/><br/>
                            <span>{translate("accueil.ami_intro_1")}</span><br/><br/>
                            <span>{translate("accueil.ami_intro_2")}</span><br/><br/>
                            <span>{translate("accueil.ami_intro_3.1")}</span>
                            <b>{translate("accueil.ami_intro_3.2")}</b>
                            <span>{translate("accueil.ami_intro_3.3")}</span><br/><br/>
                            <b>{translate("accueil.ami_intro_4.1")}</b>
                            <span>{translate("accueil.ami_intro_4.2")}</span>
                            <b>{translate("accueil.ami_intro_4.3")}</b>
                            <span>{translate("accueil.ami_intro_4.4")}</span><br/><br/>
                            <span>{translate("accueil.ami_intro_5.1")}</span><br/>
                            <span>{translate("accueil.ami_intro_5.2")}</span><br/>
                            <span>{translate("accueil.ami_intro_5.3")}</span><br/>
                            <span>{translate("accueil.ami_intro_5.4")}</span><br/>
                            <span>{translate("accueil.ami_intro_5.5")}</span><br/>
                            <span>{translate("accueil.ami_intro_5.6")}</span><br/>
                            <span>{translate("accueil.ami_intro_5.7")}</span><br/><br/>
                            <span>{translate("accueil.ami_intro_6")}</span><br/><br/>
                            <span>{translate("accueil.ami_intro_7")}</span><br/>
                            <ol style={{listStyleType: "lower-roman"}}>
                                <li>{translate("accueil.ami_intro_8")}</li>
                                <li>{translate("accueil.ami_intro_9")}</li>
                            </ol>
                            <br/>
                            <br/>
                            <h3 style={{textAlign: "center"}}>{translate("accueil.collab")}</h3>                           
                                <div className="collaboration-list">
                                    <li style={{gridColumn: "span 2"}}> 
                                        <h4>{translate("accueil.responsable_lopcus")}</h4> 
                                        <ul>
                                            <li>Chantal Viscogliosi</li>
                                        </ul> 
                                    </li>
                                    <li style={{gridColumn: "span 2"}}> 
                                        <h4>{translate("accueil.societe_mask")}</h4> 
                                        <ul>
                                            <li>Bernard Chassé</li>
                                        </ul> 
                                    </li>
                                    <li style={{gridColumn: "span 2"}}> 
                                        <h4>{translate("accueil.domus_chercheurs")}</h4> 
                                        <ul>
                                            <li>Hubert Kenfack Ngankam</li>
                                            <li>Hélène Pigot</li>
                                            <li>Sylvain Giroux</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <h4>{translate("accueil.etudiant_genie")}</h4> 
                                        <ul>
                                            <li>Yan Ha Routhier-Chevrier</li>
                                            <li>Nicolas Biard</li>
                                            <li>Olivier Lafond</li>
                                        </ul>
                                    </li>
                                    <li> 
                                        <h4>{translate("accueil.etudiant_ergo")}</h4> 
                                        <ul>
                                            <li>Jordan Duchesne</li>
                                            <li>Sabrina Jacob</li>
                                            <li>Pascale Tremblay-Perreault</li>
                                            <li>Nicolas Oryschuk</li>
                                            <li>Mélanie Caron</li>
                                        </ul>
                                    </li>
                                    <li> 
                                        <h4>{translate("accueil.ergo")}</h4> 
                                        <ul>
                                            <li>Jessica Déry</li>
                                            <li>Sarah Rahimaly</li>
                                            <li>Jordan Mino-Roy</li>
                                        </ul>
                                    </li>
                                    <li> 
                                        <h4>{translate("accueil.linguistique")}</h4> 
                                        <ul>
                                            <li>Antonin Marquis</li>
                                            <li>Nathalie Dame</li>
                                        </ul>
                                    </li>
                                    <li> 
                                        <h4>{translate("accueil.graphisme")}</h4> 
                                        <ul>
                                            <li>Mélina Brouillette</li>
                                            <li>Matéo Minillo Conselheiro</li>
                                        </ul>
                                    </li>
                                    <li> 
                                        <h4>{translate("accueil.traduction")}</h4> 
                                        <ul>
                                            <li>Sorayah Neptune</li>
                                            <li>Marianne Larin</li>
                                            <li>Aurore Bouquelle</li>
                                        </ul>
                                    </li>
                                </div>
                        </div>
                        <div className="DivLogo" style={{marginTop: "5em", marginBottom: "5em"}}>
                            <h3 style={{textAlign: "center"}}>{translate("accueil.partenaires")}</h3>
                            <img src={img_partenaires} alt='logo_partenaires' style={{maxWidth: "1000px"}}/>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
  }
  export default Accueil;